module.exports = __webpack_public_path__ + "static/customer-phone-db966200f87beb4ca0abd074fa34b8ff.jpg";